import { useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { useMyTicket, useReplyTicket, useCloseTicket } from '../api/useSupport'
import { useAuthStore } from '../store/authStore'
import { mediaUrl } from '../utils/media'
import { TICKET_STATUS_LABEL as STATUS_LABEL, TICKET_STATUS_CSS as STATUS_CSS } from '../utils/constants'
import { formatDateTime as formatDate } from '../utils/date'
import toast from 'react-hot-toast'

export default function SupportTicket() {
  const { id } = useParams()
  const { data: ticket, isLoading } = useMyTicket(id)
  const user = useAuthStore((s) => s.user)
  const [replyText, setReplyText] = useState('')
  const { mutate: reply, isPending: replying } = useReplyTicket(id)
  const { mutate: close, isPending: closing } = useCloseTicket(id)

  const handleReply = (e) => {
    e.preventDefault()
    if (!replyText.trim()) return
    reply(replyText.trim(), {
      onSuccess: () => { toast.success('Сообщение отправлено'); setReplyText('') },
      onError: () => toast.error('Ошибка'),
    })
  }

  const handleClose = () => {
    close(undefined, {
      onSuccess: () => toast.success('Обращение закрыто'),
      onError: () => toast.error('Ошибка'),
    })
  }

  if (isLoading) return <div className="max-w-2xl mx-auto px-4 py-10"><div className="h-48 rounded-2xl animate-pulse bg-surface" /></div>
  if (!ticket) return null

  const isClosed = ticket.status === 'closed'

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-10">
      <div className="flex items-center gap-3 mb-6">
        <Link to="/support" className="text-sm text-muted hover:text-accent transition-colors">← Обращения</Link>
        <span className="text-line">/</span>
        <h1 className="text-lg font-bold truncate">{ticket.subject}</h1>
        <span className={`text-xs px-2 py-0.5 rounded-full shrink-0 font-medium ml-auto ${STATUS_CSS[ticket.status] || STATUS_CSS.closed}`}>
          {STATUS_LABEL[ticket.status] || ticket.status}
        </span>
      </div>

      <div className="flex flex-col gap-3 mb-6 max-h-[480px] overflow-y-auto pr-1">
        {(ticket.messages || []).map((msg) => {
          const isAdmin = msg.is_admin
          return (
            <div key={msg.id} className={`flex gap-3 p-4 rounded-xl ${isAdmin ? 'bg-accent-dim border border-accent/20' : 'bg-surface'}`}>
              <div className="w-8 h-8 rounded-full overflow-hidden shrink-0 flex items-center justify-center text-xs font-bold bg-surface2 text-accent">
                {msg.author?.avatar_url
                  ? <img src={mediaUrl(msg.author.avatar_url)} alt="" className="w-full h-full object-cover" />
                  : (msg.author?.username || '?').slice(0, 2).toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-sm font-semibold">
                    {isAdmin ? 'Поддержка' : (msg.author?.username || 'Вы')}
                  </span>
                  {isAdmin && (
                    <span className="text-xs px-1.5 py-0.5 rounded bg-accent text-on-accent">Админ</span>
                  )}
                  <span className="text-xs text-muted ml-auto">{formatDate(msg.created_at)}</span>
                </div>
                <p className="text-sm text-fg leading-relaxed">{msg.text}</p>
              </div>
            </div>
          )
        })}
      </div>

      {!isClosed && (
        <form onSubmit={handleReply} className="flex flex-col gap-3">
          <textarea
            value={replyText}
            onChange={(e) => setReplyText(e.target.value)}
            placeholder="Ваш ответ..."
            rows={3}
            className="w-full px-3 py-2 rounded-xl text-sm outline-none bg-surface border border-line text-fg focus:border-accent transition-colors resize-none"
          />
          <div className="flex gap-2 justify-between">
            <button type="button" onClick={handleClose} disabled={closing}
              className="px-4 py-2 rounded-lg text-sm text-muted hover:text-red-400 transition-colors disabled:opacity-50">
              Закрыть обращение
            </button>
            <button type="submit" disabled={replying || !replyText.trim()}
              className="px-4 py-2 rounded-lg text-sm font-bold bg-accent text-on-accent disabled:opacity-50">
              Отправить
            </button>
          </div>
        </form>
      )}

      {isClosed && (
        <p className="text-center text-sm text-muted py-4">Обращение закрыто</p>
      )}
    </div>
  )
}
